export default () => {
  const containers = document.querySelectorAll('.js-product-sticky');
  let scrollPos = 0;
  let scrolledUp = false;

  if (containers.length < 1) return;
  window.addEventListener('scroll', handleScroll);
  const stickyHeader = document.querySelector('.c-sticky-header');
  const scrollHeight = (window.innerWidth < 768) ? 700 : 1200;

  function handleScroll() {
    scrolledUp = document.body.getBoundingClientRect().top > scrollPos;

    [...containers].forEach(header => {
      // we're NOT at the top of the page
      if (window.pageYOffset > scrollHeight) {
        if (!header.classList.contains('activated')) header.classList.add('activated');

        (stickyHeader.classList.contains('active')) 
          ? header.classList.add('activated-header') 
          : header.classList.remove('activated-header');
        // we're at the top of the page
      } else {
        if (header.classList.contains('activated')) {
          header.classList.remove('activated');
          header.classList.remove('activated-header');
        }
      }
    });

    // saves the new position for iteration.
    scrollPos = document.body.getBoundingClientRect().top;
  }
};


// WEBPACK FOOTER //
// ./src/js/modules/SingleProductSticky.js